import {attributeSelector} from '@acng/frontend-bounty/dom/query.js';
import {guard, IS} from '@acng/frontend-rubicon';
import {WatchGroup} from '@acng/frontend-relativity';
import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {ctxAmateur} from '../context/amateur.js';
import {ctxOnline, isOnline} from '../service/online.js';
import {SwapClass} from '../../layout/service/style.js';
import {Amateur} from '../model/amateur.js';

/**
 * @group DOM Attribute
 */
const name = 'class-online';

AttributeSetup(name, (name) => {
  const observe = WatchGroup(attributeSelector(name), ctxAmateur, ctxOnline);
  const swap = SwapClass(['amateur-online'], ['amateur-offline'], []);

  AttributeLink(name, (element) =>
    observe(element, (element, [amateur]) => {
      ASSERT: guard(amateur, IS(Amateur));
      swap(element, isOnline(amateur.id));
    }),
  );
});

export {name as CLASS_ONLINE};
